import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27124838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commands" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "command" }

import GuildCommand from "@/components/commands/GuildCommand"
import SelectItems from "@/utils/SelectItems";
import {computed, onMounted, Reactive, reactive, Ref, ref} from "vue";
import {Guild} from "@/types/Guild";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import { GuildSettings} from "@/types/GuildSettings";
import {Command} from "@/types/Command";
import {SubmitResult} from "@/types/SubmitResult";
import config from "@/config.json";
import {CommandSettings} from "@/types/CommandSettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildCommandsView',
  props: {
    settings: {}
  },
  emits: ['submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
const store = useStore()
const location = window.location.origin
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let roles = SelectItems.roles(guild.value!.roles!, false)
let commands = computed(() => (store.getters.commands as Array<Command>));
let settings: Reactive<GuildSettings> = reactive(JSON.parse(JSON.stringify(props.settings)));
let unauthorized = ref(false);
const categories = ['general', 'economy', 'games', 'utilities', 'moderation'];
const icons = ['public', 'attach_money', 'phone_iphone', 'build', 'security'];

function commandUpdated(result: SubmitResult, status: number, command: CommandSettings) {
  if(result === 'success') {
    settings.commands[command.name] = command
    emit('submitted', result, settings)
  }
  else emit('submitted', 'error')
  unauthorized.value = status === 401
}

onMounted(async () => {
  if (!commands.value?.length) await store.dispatch('getCommands')
  commands.value.forEach(command => {
    if (!settings.commands[command.config.en.name]) settings.commands[command.config.en.name] = {
      name: command.config.en.name,
      enabled: true,
      deleteUsage: false,
      allowedRoles: [],
      forbiddenRoles: [],
      allowedChannels: [],
      forbiddenChannels: []
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(commands).length)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          class: "item-center",
          size: "60",
          width: "5",
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    (_unref(unauthorized))
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 1,
          class: "alert",
          border: "start",
          color: "error",
          variant: "tonal",
          title: _ctx.$t(`GuildCommands.errors.title`)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`GuildCommands.errors.description1`)) + " ", 1),
            _createElementVNode("a", {
              href: `https://discord.com/api/oauth2/authorize?client_id=${_unref(config).botID}&redirect_uri=` +
      `${encodeURIComponent(_unref(location) + '/login')}&response_type=`+
      `code&scope=identify+guilds+applications.commands.permissions.update`,
              target: "_blank",
              class: "link"
            }, _toDisplayString(_ctx.$t(`GuildCommands.errors.link`)), 9, _hoisted_2),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`GuildCommands.errors.description2`)), 1)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_unref(commands).length)
      ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
          key: 2,
          variant: "accordion"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (category, i) => {
              return _createVNode(_component_v_expansion_panel, { "bg-color": "block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, {
                    class: "category",
                    ripple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "category-icon" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(icons[i]), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`GuildCommands.categories.${category}`)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commands).filter(cmd => cmd.category === category), (command, j) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", null, _toDisplayString(_unref(settings).prefix) + _toDisplayString(command.config[_unref(settings).language.commands].name), 1),
                            _createVNode(_unref(GuildCommand), {
                              name: _unref(settings).prefix + command.config[_unref(settings).language.commands].name,
                              command: _unref(settings).commands[command.config.en.name],
                              onUpdate: commandUpdated
                            }, null, 8, ["name", "command"])
                          ]),
                          (j < _unref(commands).filter(c => c.category === category).length-1)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            }), 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})